import { deleteStorage, setStorage } from "../../Util/storageHelper";
import apiErrorHelper from "../../Util/apiErrorHelper";
import setAuthHeaders from "../../Util/setAuthHeader";
import toastHelper from "../../Util/toastHelper";
import { NavigateFunction } from "react-router";
import { AppDispatch, store } from "../store";
import AuthTypes from "./AuthTypes";
import API from "../../API/API";
import axios from "axios";

export const loginUser =
  (
    credentials: {
      email: string;
      password: string;
    },
    openOtpModalHandler?: () => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.LOGIN_LOADING });

    try {
      const { data } = await axios({
        method: API.members.login.method,
        url: API.members.login.url,
        data: credentials,
      });
      openOtpModalHandler?.();

      dispatch({
        type: AuthTypes.LOGIN_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.LOGIN_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const submitOtp =
  (
    params: { otpCode: string; email: string },
    openPasswordModalHandler: () => void,
    successHandler: () => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.SUBMIT_OTP_LOADING });
    try {
      const { data } = await axios({
        method: API.members.submitOtp.method,
        url: API.members.submitOtp.url,
        data: params,
      });

      if (data?.isFirstLogin) {
        setAuthHeaders(data?.token);
        openPasswordModalHandler?.();
        dispatch({
          type: AuthTypes.SUBMIT_OTP_SUCCESS_WITH_FIRST_LOGIN,
          payload: data,
        });
      } else {
        setAuthHeaders(data?.token);
        setStorage("token", {
          token: data?.token,
        });
        const { data: profileData } = await axios({
          method: API.members.profile.method,
          url: API.members.profile.url,
        });

        dispatch({
          type: AuthTypes.SUBMIT_OTP_SUCCESS,
          payload: {
            token: data?.token,
            user: profileData,
          },
        });

        successHandler();
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.SUBMIT_OTP_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const loginAdmin =
  (
    credentials: {
      email: string;
      password: string;
    },
    navigate: NavigateFunction,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.ADMIN_LOGIN_LOADING,
    });

    try {
      const { data } = await axios({
        method: API.admin.login.method,
        url: API.admin.login.url,
        data: credentials,
      });

      setAuthHeaders(data?.token);

      setStorage("adminData", {
        adminData: {
          token: data?.token,
          admin: data?.admin,
        },
      });

      dispatch({
        type: AuthTypes.ADMIN_LOGIN_SUCCESS,
        payload: {
          token: data?.token,
          admin: data?.admin,
        },
      });

      if (data?.admin?.role === "DoorLogAdmin") {
        navigate("/admin/reports/doorhistory");
      } else {
        navigate("/admin");
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.ADMIN_LOGIN_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const verifyUser = (token: string) => async (dispatch: AppDispatch) => {
  dispatch({ type: AuthTypes.VERIFY_LOADING });

  try {
    const { data } = await axios({
      method: API.members.profile.method,
      url: API.members.profile.url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setAuthHeaders(token);

    setStorage("token", {
      token,
    });
    dispatch({
      type: AuthTypes.VERIFY_SUCCESS,
      payload: {
        token,
        user: data,
      },
    });
  } catch (error: any) {
    deleteStorage("token");
    setAuthHeaders("");

    if (error?.response?.data?.message) {
      toastHelper.error(error?.response?.data?.message);
    } else {
      toastHelper.error("Something went wrong");
    }
    dispatch({
      type: AuthTypes.VERIFY_ERROR,
      payload: JSON.stringify(apiErrorHelper(error)),
    });
  }
};

export const verifyAdmin =
  (adminData: any) => async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.ADMIN_VERIFY_LOADING,
    });

    try {
      setAuthHeaders(adminData?.token);

      dispatch({
        type: AuthTypes.ADMIN_VERIFY_SUCCESS,
        payload: {
          token: adminData?.token,
          admin: adminData?.admin,
        },
      });
    } catch (error: any) {
      deleteStorage("adminData");
      setAuthHeaders("");

      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.ADMIN_VERIFY_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const getMemberByEmail =
  (params: { email: string; nextStepHandler: () => void }) =>
  async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.GET_MEMBER_BY_EMAIL_LOADING,
    });
    try {
      const { data } = await axios({
        method: API.members.memberByEmail.method,
        url: API.members.memberByEmail.url + `/${params.email}`,
      });
      dispatch({
        type: AuthTypes.GET_MEMBER_BY_EMAIL,
        payload: data,
      });
      params.nextStepHandler();
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.GET_MEMBER_BY_EMAIL_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const signupUser =
  (
    params: {
      email: string;
      password: string;
      packageId: number;
      content: string;
      signature: string;
      cardNumber: string;
      cardName: string;
      cvv: string;
      expiry: string;
      slots: Array<{
        parkingId: string;
        noOfVehicle: number;
        notifyParking: boolean;
      }>;
      addons: Array<{
        addonId: number;
        noofAddonUnits: number;
        notifyAddon: boolean;
      }>;
      familyMember: any[];
      voucherCode: string;
    },
    successHandler: () => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.SIGNUP_LOADING });

    try {
      const { data } = await axios({
        method: API.members.signup.method,
        url: API.members.signup.url,
        data: params,
      });

      dispatch({
        type: AuthTypes.SIGNUP_SUCCESS,
        payload: {
          token: data?.token,
        },
      });
      successHandler();
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.SIGNUP_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const nonMemberSignupUser =
  (
    params: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      buildingId: number;
      email: string;
      password: string;
      packageId: number;
      content: string;
      signature: string;
      cardNumber: string;
      cardName: string;
      cvv: string;
      expiry: string;
      addons: Array<{
        addonId: number;
        noofAddonUnits: number;
        notifyAddon: boolean;
      }>;
      slots: Array<{
        parkingId: string;
        noOfVehicle: number;
        notifyParking: boolean;
      }>;
      familyMember: any[];
      voucherCode: string;
    },
    successHandler: () => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.SIGNUP_LOADING });

    try {
      const { data } = await axios({
        method: API.members.signup.method,
        url: API.members.signup.url,
        data: params,
      });

      dispatch({
        type: AuthTypes.SIGNUP_SUCCESS,
        payload: {
          token: data?.token,
        },
      });
      successHandler();
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.SIGNUP_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const nonMemberSignupUserWithoutPackage =
  (
    params: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      buildingId: number;
      email: string;
      password: string;
      packageId: number | null;
      content: string;
      signature: string;
      cardNumber: string;
      cardName: string;
      cvv: string;
      expiry: string;
      addons: Array<{
        addonId: number;
        noofAddonUnits: number;
        notifyAddon: boolean;
      }>;
      slots: Array<{
        parkingId: string;
        noOfVehicle: number;
        notifyParking: boolean;
      }>;
      familyMember: any[];
      voucherCode: string;
    },
    successHandler: () => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.SIGNUP_LOADING });

    try {
      const { data } = await axios({
        method: API.members.signupWithoutPackage.method,
        url: API.members.signupWithoutPackage.url,
        data: params,
      });

      dispatch({
        type: AuthTypes.SIGNUP_SUCCESS,
        payload: {
          token: data?.token,
        },
      });
      successHandler();
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.SIGNUP_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const userForgotPassword =
  (params: { email: string }) => async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.FORGOT_PASSWORD_OTP_LOADING,
    });

    try {
      const { data } = await axios({
        method: API.members.forgotPassword.method,
        url: API.members.forgotPassword.url,
        data: params,
      });

      toastHelper.success(data?.message);

      dispatch({
        type: AuthTypes.FORGOT_PASSWORD_OTP_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.FORGOT_PASSWORD_OTP_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const getBuildingsByZipCode =
  (params: { zipCode: string }) => async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.GET_BUILDINGS_BY_ZIP_CODE_LOADING,
    });

    try {
      const { data } = await axios({
        method: API.members.getBuildingsByZipCode.method,
        url: API.members.getBuildingsByZipCode.url + params.zipCode,
      });

      dispatch({
        type: AuthTypes.GET_BUILDINGS_BY_ZIP_CODE_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.GET_BUILDINGS_BY_ZIP_CODE_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const userResetPassword =
  (params: {
    email: string;
    otpCode: string;
    newPassword: string;
    confirmPassword: string;
    successHandler: () => void;
  }) =>
  async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.RESET_PASSWORD_LOADING,
    });

    try {
      const { data } = await axios({
        method: API.members.resetPassword.method,
        url: API.members.resetPassword.url,
        data: params,
      });

      toastHelper.success(data?.message);

      dispatch({
        type: AuthTypes.RESET_PASSWORD_SUCCESS,
        payload: data,
      });
      params.successHandler();
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.RESET_PASSWORD_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const updateFirstLoginPassword =
  (
    params: { email: string; password: string; signature: string },
    successHandler: () => void,
    navigate: NavigateFunction,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({
      type: AuthTypes.UPDATE_FIRST_LOGIN_PASSWORD_LOADING,
    });
    try {
      const { data } = await axios({
        method: API.members.updateFirstLoginPassword.method,
        url: API.members.updateFirstLoginPassword.url,
        data: params,
      });

      dispatch({
        type: AuthTypes.UPDATE_FIRST_LOGIN_PASSWORD_SUCCESS,
        payload: data,
      });
      const { data: profileData } = await axios({
        method: API.members.profile.method,
        url: API.members.profile.url,
      });
      setAuthHeaders(store.getState().auth.submitOtpData?.token);
      setStorage("token", {
        token: store.getState().auth.submitOtpData?.token,
      });
      dispatch({
        type: AuthTypes.SUBMIT_OTP_SUCCESS,
        payload: {
          token: store.getState().auth.submitOtpData?.token,
          user: profileData,
        },
      });
      successHandler();
      toastHelper.success(data?.message);
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      dispatch({
        type: AuthTypes.UPDATE_FIRST_LOGIN_PASSWORD_ERROR,
        payload: JSON.stringify(apiErrorHelper(error)),
      });
    }
  };

export const clearForgotPasswordOTP = () => async (dispatch: AppDispatch) => {
  dispatch({
    type: AuthTypes.FORGOT_PASSWORD_OTP_CLEAR,
  });
};

export const logoutUser = () => async (dispatch: AppDispatch) => {
  deleteStorage("token");
  setAuthHeaders("");
  dispatch({
    type: AuthTypes.LOGOUT,
  });
};

export const logoutAdmin = () => async (dispatch: AppDispatch) => {
  deleteStorage("adminData");
  setAuthHeaders("");
  dispatch({
    type: AuthTypes.LOGOUT_ADMIN,
  });
};

export const clearMemberByEmail = () => async (dispatch: AppDispatch) => {
  dispatch({
    type: AuthTypes.GET_MEMBER_BY_EMAIL_CLEAR,
  });
};

export const clearNonMemberData = () => async (dispatch: AppDispatch) => {
  dispatch({
    type: AuthTypes.CLEAR_NON_MEMBER_DATA,
  });
};
